// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chevron-right.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/chevron-right'

import { Icon, type IconComponentProps } from '../icon'

export const ChevronRightIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
